<template>
  <div>
    <div v-if="mdFilePath">
      {{ fetchMd() }}
      <div v-html="markdownToHtml"></div>
    </div>
    <div v-else>
      <div v-html="markdownToText"></div>
    </div>
  </div>
</template>

<script>
import { marked } from 'marked';

export default {
  name: 'InsertMarkdown',
  props: {
    mdFilePath: {
      type: String,
      default: () => '',
    },
    text: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      mdText: '',
    };
  },
  methods: {
    fetchMd() {
      fetch(this.mdFilePath)
        .then((res) => res.text())
        .then((text) => (this.mdText = text));
    },
  },
  computed: {
    markdownToHtml() {
      return marked(this.mdText);
    },
    markdownToText() {
      return marked(this.text);
    },
  },
};
</script>
